import { styled } from "./stiches.config";
export const StyledColumn = styled("div", {
  padding: "22px",
  display: "flex",
  width: "49%",
  height: "70vh",
});

export const StyledList = styled("div", {
  backgroundColor: "#E5E5E5",
  borderRadius: 8,
  width: "100%",
  height: "70vh",
});

export const StyledItem = styled("div", {
  backgroundColor: "white",
  borderRadius: 8,
  // height: "83px",
  marginBottom: "29px",
  width: "calc(100% - 16px)",
});

export const StyledItemMain = styled("div", {
  backgroundColor: "white",
  borderRadius: 4,
  height: "80px",
  padding: "4px 8px",
  width: "calc(100% - 16px)",
});

export const StyledColumns = styled("div", {
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
});

export const initialColumns = {
  sub: {
    id: "sub",
    list: [
      {
        title: "firstName",
        id: 1,
        isRequired: true,
        isShowRequired: false,
        showClose: true,
      },
      {
        title: "lastName",
        id: 3,
        isRequired: true,
        isShowRequired: false,
        showClose: true,
      },
      {
        title: "email",
        id: 10,
        isRequired: true,
        isShowRequired: false,
        showClose: true,
      },
    ],
  },
  main: {
    id: "main",
    list: [
      {
        title: "uploadPhoto",
        id: 0,
        isRequired: false,
        isShowRequired: true,
      },
      { title: "middleName", id: 2, isRequired: false, isShowRequired: true },
      { title: "primaryPhoneNumber", id: 18, isRequired: false, isShowRequired: true },
      {
        title: "leadStatus",
        id: 16,
        isRequired: false,
        isShowRequired: true,
      },
       { title: "interestedProduct", id: 20, isRequired: false, isShowRequired: true },
      { title: "preferredContactMode", id: 4, isRequired: false, isShowRequired: true },
      { title: "company", id: 5, isRequired: false, isShowRequired: true },
      { title: "age", id: 7, isRequired: false, isShowRequired: true },
      {
        title: "maritalStatus",
        id: 8,
        isRequired: false,
        isShowRequired: true,
      },
      {
        title: "secondaryPhoneNumber",
        id: 9,
        isRequired: false,
        isShowRequired: true,
      },
      {
        title: "secondaryEmail",
        id: 27,
        isRequired: false,
        isShowRequired: true,
      },
      { title: "website", id: 11, isRequired: false, isShowRequired: true },
      { title: "fax", id: 12, isRequired: false, isShowRequired: true },
      { title: "industry", id: 13, isRequired: false, isShowRequired: true },
      {
        title: "designation",
        id: 14,
        isRequired: false,
        isShowRequired: true,
      },
      {
        title: "description",
        id: 26,
        isRequired: false,
        isShowRequired: true,
      },
      {
        title: "address",
        id: 25,
        isRequired: false,
        isShowRequired: true,
      },
      // { title: "city", id: 17, isRequired: false, isShowRequired: true },
      // { title: "state", id: 18, isRequired: false, isShowRequired: true },
      // { title: "country", id: 19, isRequired: false, isShowRequired: true },
      // { title: "zipcode", id: 20, isRequired: false, isShowRequired: true },
      // {
      //   title: "description",
      //   id: 21,
      //   isRequired: false,
      //   isShowRequired: true,
      // },
    ],
  },
};